import React, { useEffect, useState } from 'react';
import { Heart, Users, Award, Clock } from 'lucide-react';
import { Link } from 'react-router-dom'
import axios from 'axios'

import { team as getTeam } from './team';
import './about.css';

const AboutPage = () => {

    const [scrollY, setScrollY] = useState(0);
    const team = getTeam();

    useEffect(() => {
        const handleScroll = () => setScrollY(window.scrollY);
        window.addEventListener('scroll', handleScroll);
        return () => window.removeEventListener('scroll', handleScroll);

    }, []);

    const heroOpacity = Math.max(0, 1 - scrollY / 500);
    const heroScale = Math.max(0.9, 1 - scrollY / 2000);


    // If you want to log team data, do it in a useEffect so it only runs once
    useEffect(() => {
        console.log('Team data:', team);
    }, []);
    return (

        <>
            <div className="about-container">

                {/* Hero Section */}
                <section
                    className="hero-section"
                    style={{
                        opacity: heroOpacity,
                        transform: `scale(${heroScale})`
                    }}
                >
                    <div className="hero-overlay"></div>
                    <div className="hero-gradient"></div>

                    {/* Animated background elements */}
                    <div className="hero-bg-animation">
                        <div className="hero-blob hero-blob-1"></div>
                        <div className="hero-blob hero-blob-2"></div>
                    </div>

                    <div className="hero-content">
                        <div className="hero-icon-wrapper">
                            <Heart className="hero-icon" strokeWidth={1.5} />
                        </div>
                        <h1 className="hero-title">
                            At Midtown Pharmacy,<br />
                            <span className="hero-subtitle">your health is our priority</span>
                        </h1>
                        {/* <p className="hero-description">
                            Serving our community with compassion and excellence since 1998
                        </p> */}
                    </div>

                    {/* <div className="scroll-indicator">
                        <div className="scroll-indicator-border">
                            <div className="scroll-indicator-dot"></div>
                        </div>
                    </div> */}
                </section>

                {/* Mission Section */}
                <section className="mission-section">
                    <div className="mission-container">
                        <div className="mission-grid">
                            <div className="mission-content">
                                <div className="mission-badge">
                                    Our Mission
                                </div>
                                <h2 className="mission-title">
                                    Dedicated to Your Wellbeing
                                </h2>
                                <p className="mission-text">
                                    We believe that exceptional pharmacy care goes beyond filling prescriptions. It's about building relationships, understanding individual needs, and providing personalized support every step of the way.
                                </p>
                                <p className="mission-text-secondary">
                                    Our team combines cutting-edge pharmaceutical knowledge with a genuine commitment to your health, ensuring you receive not just medication, but comprehensive care and guidance.
                                </p>
                            </div>

                            <div className="mission-cards">
                                {[
                                    { icon: Users, title: "Community Focused", desc: "Serving 10,000+ families" },
                                    { icon: Award, title: "Expert Care", desc: "25+ years of experience" },
                                    { icon: Clock, title: "Always Available", desc: "Extended hours & delivery" },
                                    { icon: Heart, title: "Personal Touch", desc: "One-on-one consultations" }
                                ].map((item, idx) => (
                                    <div key={idx} className="mission-card">
                                        <div className="mission-card-icon-wrapper">
                                            <item.icon className="mission-card-icon" />
                                        </div>
                                        <h3 className="mission-card-title">{item.title}</h3>
                                        <p className="mission-card-desc">{item.desc}</p>
                                    </div>
                                ))}
                            </div>
                        </div>
                    </div>
                </section>

                {/* Team Section */}
                <section className="team-section">
                    <div className="team-container">
                        <div className="team-header">
                            <div className="team-badge">
                                Meet Our Team
                            </div>
                            <h2 className="team-title">
                                The People Behind Your Care
                            </h2>
                            <p className="team-description">
                                Our experienced team is here to support you with expertise, compassion, and a genuine commitment to your health.
                            </p>
                        </div>

                        <div className="team-grid">
                            {team.map((member, idx) => (
                                <div key={idx} className="team-member">
                                    <div className="team-member-card">
                                        <div className="team-member-image-wrapper">
                                            <img
                                                src={member.image}
                                                alt={member.name}
                                                className="team-member-image"
                                            />
                                        </div>
                                        {/* <div className="team-member-overlay"></div> */}
                                        {/* <div className="team-member-info">
                                            <h3 className="team-member-name">{member.name}</h3>
                                            <p className="team-member-role">{member.role}</p>
                                        </div> */}
                                    </div>
                                    <div className="team-member-info">
                                        <h3 className="team-member-name">{member.name}</h3>
                                        <p className="team-member-role">{member.role}</p>
                                    </div>
                                </div>
                            ))}
                        </div>
                    </div>
                </section>

                {/* Footer CTA */}
                <section className="cta-section">
                    <div className="cta-container">
                        <h2 className="cta-title">
                            Ready to experience the Midtown difference?
                        </h2>
                        <p className="cta-description">
                            Visit us today or give us a call to learn more about our services.
                        </p>
                        <button className="cta-button">
                            <Link to='/contact'>
                                Contact Us
                            </Link>
                        </button>
                    </div>
                </section>
            </div>


        </>

    )

};

export default AboutPage;